/// <amd-module name="Repos/Common/Util/BidiDetector" />

const bidiCharactersRegex = "[\u202A-\u202E]|[\u2066-\u2069]";

export function detectBidiCharacterInLine(line: string) {
    return line?.match(bidiCharactersRegex);
}

export function detectBidiCharacterInArray(lineArray: string[]) {
    return lineArray?.find(detectBidiCharacterInLine);
}
